var map = {
	"./bottom-copy-banner/index.js": [
		6143,
		847
	],
	"./cart/index.js": [
		446,
		334
	],
	"./category-carousel/index.js": [
		6210,
		283
	],
	"./collection-banner/index.js": [
		4667,
		641
	],
	"./countdown-timer/index.js": [
		5029,
		436
	],
	"./customer/addresses/index.js": [
		6745,
		532,
		651
	],
	"./example/index.js": [
		4091,
		532,
		484
	],
	"./explore-collection/index.js": [
		6223,
		842
	],
	"./footer/index.js": [
		408,
		78
	],
	"./header/index.js": [
		448,
		980
	],
	"./hero/index.js": [
		2424,
		305
	],
	"./image-grid/index.js": [
		9111,
		864
	],
	"./image-text-carousel/index.js": [
		879,
		532,
		922
	],
	"./product-carousel/index.js": [
		8612,
		201
	],
	"./product-grid/index.js": [
		5658,
		207,
		618
	],
	"./product/index.js": [
		8548,
		886
	],
	"./promotional-banner/index.js": [
		7264,
		770
	],
	"./recently-viewed/index.js": [
		8950,
		532,
		807
	],
	"./recommended-products/index.js": [
		1697,
		686
	],
	"./search-panel/index.js": [
		4147,
		610
	],
	"./search-results/index.js": [
		2457,
		207,
		627
	],
	"./slider/index.js": [
		7014
	],
	"./utils/storefront/index.js": [
		5509
	],
	"./yotpo-ugc/index.js": [
		3958,
		532,
		557
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6356;
module.exports = webpackAsyncContext;